module.exports = __webpack_public_path__ + "static/media/browse.421079a5.svg";